<template>
  <div class="fds">
    <row>
      <column>
        <label for="account-relation-selection">
          Who can view this record on their dashboard?
          <help-tooltip>
            Select Account relationships that can also view this model's records on their dashboard.
          </help-tooltip>
        </label>
      </column>
    </row>

    <div class="mb-2">
      <button @click="buttonClicked" class="btn input-color dropdown-toggle arrow full-sz text-left">
        Select accounts...
      </button>

      <context-menu
        ref="contextMenu"
        :state="modalStateFor(vueModalID.dynamicContentPopup)"
        :index="vueModalID.dynamicContentPopup"
        fixed
        @close="hideModal(vueModalID.dynamicContentPopup)"
      >
        <deterministic-dynamic-fields-tree
          :fields-handler="fieldsHandler"
          unsearchable
          @select="handleSelect"
        />
      </context-menu>
    </div>

    <chip-list
      :chips="referencePaths"
      display-key="dynamicFieldName"
      :rootId="selectedObjectModel.client_id"
      @destroy="handleDestroy"
      pill-color="Sepia"
    ></chip-list>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import ContextMenu from "~/components/contextMenu.vue";
import DeterministicDynamicFieldsTree from '~/components/dynamicFieldsTrees/deterministic-dynamic-fields-tree.vue';
import ObjectModelAccountRelationDynamicFieldsHandler from '~/models/dynamicFields/handlers/objectModelAccountRelationDynamicFieldsHandler'
import selectedMixin from '../mixins/selectedMixin'
import DynamicFieldsHandler from '~/models/dynamicFields/handlers/dynamicFieldsHandler'
import { IDynamicDataConfig } from '~/interfaces/dynamicFieldsInterfaces'
import { ReferencePath } from '~/models/referencePaths/referencePath'
import ChipList from "~/components/chips/chipList.vue";

export default Vue.extend({
  mixins: [selectedMixin],
  components: {
    DeterministicDynamicFieldsTree,
    ContextMenu,
    ChipList,
  },
  data: function() {
    return {
    };
  },
  computed: {
    referencePaths(): ReferencePath[] {
      return this.selectedObjectModel.dashboardAccountRelationReferencePathsArray
    },
    fieldsHandler(): DynamicFieldsHandler {
      return new ObjectModelAccountRelationDynamicFieldsHandler({
        objectModel: this.selectedObjectModel,
        previouslySelected: this.referencePaths
      })
    },
  },
  methods: {
    buttonClicked(event): void {
      this.showModal(this.vueModalID.dynamicContentPopup);
      this.$refs.contextMenu.open(event);
    },
    handleSelect(config: IDynamicDataConfig): void {
      this.hideModal(this.vueModalID.dynamicContentPopup)

      const json = {
        nodes: config.path.map((referenceNode) => referenceNode.asJson())
      }
      const referencePath = this.selectedObjectModel.createEmbeddedObject.dashboard_account_relation_reference_paths(
        this.selectedObjectModel,
        json
      )
      referencePath.attachToParent(this.selectedObjectModel)
    },
    handleDestroy(referencePath: ReferencePath): void {
      referencePath.destroy()
    },
  }
});
</script>